import './BrandLogo.css';

const LOGO_SRC = {
  light: '/idrivea-logo.png',
  dark: '/idrivea-logo-dark.png',
};

export default function BrandLogo({
  variant = 'image',
  tone = 'light',
  surface = 'light',
  size = 'md',
  className = '',
}) {
  if (variant === 'text') {
    return (
      <span className={`brand-wordmark brand-wordmark--${tone} ${className}`.trim()}>
        <span className="brand-wordmark-i">i</span>
        <span className="brand-wordmark-drive">DRIVEA</span>
      </span>
    );
  }

  return (
    <img
      src={LOGO_SRC[surface]}
      alt="iDRIVEA"
      className={`brand-logo-img brand-logo-img--${size} ${className}`.trim()}
    />
  );
}
